'use client';

import { cn, formatUSD } from '@/lib/utils';

interface MoneyDisplayProps {
  amount: bigint | number | string;
  showSign?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function MoneyDisplay({
  amount,
  showSign = false,
  size = 'md',
  className,
}: MoneyDisplayProps) {
  const numAmount = typeof amount === 'string' 
    ? Number(BigInt(amount)) / 1e6 
    : typeof amount === 'bigint' 
      ? Number(amount) / 1e6 
      : amount;

  const isPositive = numAmount > 0;
  const isNegative = numAmount < 0;

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <span
      className={cn(
        'font-mono',
        sizeClasses[size],
        showSign && isPositive && 'text-win-green',
        showSign && isNegative && 'text-loss-red',
        !showSign && 'text-grid-white',
        className
      )}
    >
      {formatUSD(numAmount, { showSign })}
    </span>
  );
}
